export default __webpack_public_path__ + "static/media/factory.9c3e0ff3.svg";